import { createSignal, Show } from "solid-js";
import { Text } from "./i18n";

export const [appNeedsUpdate, setAppNeedsUpdate] = createSignal(false);
export const [appNeedsUpdateOk, setAppNeedsUpdateOk] = createSignal(false);
export const [appNeedsUpdateDismiss, setAppNeedsUpdateDismiss] = createSignal(false);

const AppNeedsUpdate = () => {
  return (
    <Show when={appNeedsUpdate()}>
      <div class="bg-panel absolute right-0 bottom-0 left-0 z-50 flex items-center justify-center gap-2 p-4">
        <Text message="New version available!" />
        <button
          class="ui-btn ui-btn-primary"
          onClick={() => {
            setAppNeedsUpdateOk(true);
            setAppNeedsUpdate(false);
          }}
        >
          <Text message="Refresh now" />
        </button>
        <button
          class="ui-btn ui-btn-secondary"
          onClick={() => {
            setAppNeedsUpdateDismiss(true);
            setAppNeedsUpdate(false);
          }}
        >
          <Text message="Refresh later" />
        </button>
      </div>
    </Show>
  );
};
export default AppNeedsUpdate;
